import { LightningBoltIcon } from './LightningBoltIcon';

export const GiphyBadge = () => (
  <div className='giphy-icon__wrapper'>
    <LightningBoltIcon />
    <p className='giphy-icon__text'>GIPHY</p>
  </div>
);